export default __webpack_public_path__ + "static/media/040-treasure.fb8baaa0.png";